<template>
  <div :id="id" class="layout-container px-0 container-fluid">
    <div class="layout-container px-0">
      <!--Botones de Sección-->
      <div class="btn-edit d-flex flex-column">
        <!--Boton de Editar Sección-->
        <b-dropdown
          id="dropdownu"
          right
          text="Editar"
          variant="dark"
          size="sm"
          class="m-md-2"
          :class="{ ocultarClass: esHome }"
        >
          <!-- Boton y modal para cambiar el nombre a la seccion -->
          <b-dropdown-item v-b-modal="this.id + 'changeName'">
            <font-awesome-icon icon="pencil-alt" />Cambiar nombre de seccion
          </b-dropdown-item>
          <!-- Boton editar fondo -->
          <b-dropdown-item v-b-modal="this.id + 'modal-bg'">
            <font-awesome-icon icon="fill-drip" />Editar Fondo
          </b-dropdown-item>
          <!-- Botón editar layout -->
          <b-dropdown-item v-b-modal="this.id + 'modal-layouts'">
            <font-awesome-icon icon="object-group" />Cambiar Layout
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <b-modal
        :id="this.id + 'changeName'"
        :ref="this.id + 'changeName'"
        hide-footer
        title="Cambiar el nombre de la sección"
        no-close-on-backdrop
      >
        <form ref="form" @submit="onSubmit" @submit.stop.prevent>
          <b-form-group
            :state="nameState"
            label="Nombre"
            label-for="name-input"
            invalid-feedback="El nombre es requerido"
          >
            <b-form-input id="name-input" v-model="name" required></b-form-input>
            <label class="mt-2" for="favcolor">Color del título:</label>
            <b-form-input ref="colorTitle" type="color" v-model="colorTitle" name="colorTitle"></b-form-input>
          </b-form-group>
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <div class="d-flex justify-content-end">
            <b-button size="sm" variant="secondary" @click="close()">Cancelar</b-button>
            <b-button class="ml-1" size="sm" type="submit" variant="success">Guardar</b-button>
          </div>
        </form>
      </b-modal>

      <!-- <div v-switch="selected_layout"> -->
      <!--NOTE LAYOUT 1-->
      <div v-if="selected_layout == 'uno'" key="layout-uno">
        <div id="uno" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>

            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 1var-->
      <div v-if="selected_layout == 'unovar'" key="layout-1ver">
        <div id="uno-var" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col-sm-6 mx-auto m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 2-->
      <div v-if="selected_layout == 'dos'" key="layout-dos">
        <div id="dos" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>

            <div class="row">
              <div
                :id="id + 'title'"
                class="col m-2 title-section"
                :style="'color: ' + colorTitle"
              >{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 2var-->
      <div v-if="selected_layout == 'dosvar'" key="layout-2var">
        <div id="dos-var" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col-sm-6 mx-auto m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
              <div cl ass="row">
                <div class="col-sm-6 mx-auto m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 3-->
      <div v-if="selected_layout == 'tres'" key="layout-tres">
        <div id="tres" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>

            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer2">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 3var-->
      <div v-if="selected_layout == 'tresvar'" key="layout-3var">
        <div id="tres-var" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col-sm-6 float-left m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
              <div class="row d-flex justify-content-end">
                <div class="col-sm-6 m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 float-left m-2 element" ref="bgcontainer2">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 4-->
      <div v-if="selected_layout == 'cuatro'" key="layout-cuatro">
        <div id="cuatro" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
                <div class="col m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer2">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
                <div class="col m-2 element" ref="bgcontainer3">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 3)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 3)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements3" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="3"
                      :data="data[3]"
                      :id="id + '-element3' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements3')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements3')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 5-->
      <div v-if="selected_layout == 'cinco'" key="layout-cinco">
        <div id="cinco" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
                <div class="col m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 6-->
      <div v-if="selected_layout == 'seis'" key="layout-seis">
        <div id="seis" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
                <div class="col m-2">
                  <div class="row">
                    <div class="col mb-2 element" ref="bgcontainer1">
                      <div class="btns-menu">
                        <!--Boton de Editar Subsección-->
                        <b-dropdown
                          :id="'editarSub-' + id"
                          size="sm"
                          right
                          :class="{ ocultarClass: esHome }"
                          text="Editar Subsección"
                          variant="primary"
                        >
                          <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                            <font-awesome-icon icon="fill-drip" />Editar fondo
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="
                              ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                            "
                          >
                            <font-awesome-icon icon="fill-drip" />Agregar borde
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                        <Elemento
                          :elementid="index"
                          :idSection="id"
                          :subid="1"
                          :data="data[1]"
                          :id="id + '-element1' + index"
                          :esHome="esHome"
                          :online="online"
                        />
                        <b-badge
                          :class="{ ocultarClass: esHome }"
                          href="#"
                          variant="danger"
                          class="align-self-start delElement"
                          v-on:click="deleteElement(index, 'elements1')"
                        >
                          <font-awesome-icon icon="times" />
                        </b-badge>
                      </div>
                      <b-button
                        block
                        variant="success"
                        :class="{ ocultarClass: esHome }"
                        @click="addElement('elements1')"
                        size="sm"
                      >
                        <font-awesome-icon icon="plus" />Agregar elemento
                      </b-button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col element" ref="bgcontainer2">
                      <div class="btns-menu">
                        <!--Boton de Editar Subsección-->
                        <b-dropdown
                          :id="'editarSub-' + id"
                          size="sm"
                          right
                          :class="{ ocultarClass: esHome }"
                          text="Editar Subsección"
                          variant="primary"
                        >
                          <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                            <font-awesome-icon icon="fill-drip" />Editar fondo
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="
                              ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                            "
                          >
                            <font-awesome-icon icon="fill-drip" />Agregar borde
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                        <Elemento
                          :elementid="index"
                          :idSection="id"
                          :subid="2"
                          :data="data[2]"
                          :id="id + '-element2' + index"
                          :esHome="esHome"
                          :online="online"
                        />
                        <b-badge
                          :class="{ ocultarClass: esHome }"
                          href="#"
                          variant="danger"
                          class="align-self-start delElement"
                          v-on:click="deleteElement(index, 'elements2')"
                        >
                          <font-awesome-icon icon="times" />
                        </b-badge>
                      </div>
                      <b-button
                        block
                        variant="success"
                        :class="{ ocultarClass: esHome }"
                        @click="addElement('elements2')"
                        size="sm"
                      >
                        <font-awesome-icon icon="plus" />Agregar elemento
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 6var-->
      <div v-if="selected_layout == 'seisvar'" key="layout-6var">
        <div id="seis-var" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2">
                  <div class="row">
                    <div class="col mb-2 element" ref="bgcontainer0">
                      <!--Boton de Editar Subsección-->
                      <div class="btns-menu">
                        <b-dropdown
                          :id="'editarSub-' + id"
                          size="sm"
                          right
                          :class="{ ocultarClass: esHome }"
                          text="Editar Subsección"
                          variant="primary"
                        >
                          <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                            <font-awesome-icon icon="fill-drip" />Editar fondo
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="
                              ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                            "
                          >
                            <font-awesome-icon icon="fill-drip" />Agregar borde
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <!--FIN Boton de Editar Subsección-->
                      <!--array elements -->
                      <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                        <Elemento
                          :elementid="index"
                          :idSection="id"
                          :subid="0"
                          :data="data[0]"
                          :id="id + '-element0' + index"
                          :esHome="esHome"
                          :online="online"
                        />
                        <b-badge
                          :class="{ ocultarClass: esHome }"
                          href="#"
                          variant="danger"
                          class="align-self-start delElement"
                          v-on:click="deleteElement(index, 'elements0')"
                        >
                          <font-awesome-icon icon="times" />
                        </b-badge>
                      </div>
                      <b-button
                        block
                        variant="success"
                        :class="{ ocultarClass: esHome }"
                        @click="addElement('elements0')"
                        size="sm"
                      >
                        <font-awesome-icon icon="plus" />Agregar elemento
                      </b-button>
                      <!--FIN array elements-->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col element" ref="bgcontainer1">
                      <!--Boton de Editar Subsección-->
                      <div class="btns-menu">
                        <b-dropdown
                          :id="'editarSub-' + id"
                          size="sm"
                          right
                          :class="{ ocultarClass: esHome }"
                          text="Editar Subsección"
                          variant="primary"
                        >
                          <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                            <font-awesome-icon icon="fill-drip" />Editar fondo
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="
                              ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                            "
                          >
                            <font-awesome-icon icon="fill-drip" />Agregar borde
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <!--FIN Boton de Editar Subsección-->
                      <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                        <Elemento
                          :elementid="index"
                          :idSection="id"
                          :subid="1"
                          :data="data[1]"
                          :id="id + '-element1' + index"
                          :esHome="esHome"
                          :online="online"
                        />
                        <b-badge
                          :class="{ ocultarClass: esHome }"
                          href="#"
                          variant="danger"
                          class="align-self-start delElement"
                          v-on:click="deleteElement(index, 'elements1')"
                        >
                          <font-awesome-icon icon="times" />
                        </b-badge>
                      </div>
                      <b-button
                        block
                        variant="success"
                        :class="{ ocultarClass: esHome }"
                        @click="addElement('elements1')"
                        size="sm"
                      >
                        <font-awesome-icon icon="plus" />Agregar elemento
                      </b-button>
                    </div>
                  </div>
                </div>
                <div class="col m-2 element" ref="bgcontainer2">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- NOTE LAYOUT 7-->
      <div v-if="selected_layout == 'siete'" key="layout-siete">
        <div id="siete" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
                <div class="col m-2 element" ref="bgcontainer2">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 7var-->
      <div v-if="selected_layout == 'sietevar'" key="layout-7var">
        <div id="siete-var" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
                <div class="col m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer2">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT 8-->
      <div v-if="selected_layout == 'ocho'" key="layout-ocho">
        <div id="ocho" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 3)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 3)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements3" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="3"
                      :data="data[3]"
                      :id="id + '-element3' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements3')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements3')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- NOTE LAYOUT 9-->
      <div v-if="selected_layout == 'nueve'" key="layout-nueve">
        <div id="siete" class="section container-fluid layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer0">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 0)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 0)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements0" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="0"
                      :data="data[0]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements0')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements0')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer1">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 1)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 1)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements1" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="1"
                      :data="data[1]"
                      :id="id + '-element1' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements1')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements1')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
                <div class="col m-2 element" ref="bgcontainer2">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 2)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 2)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <div class="soyrelative" v-for="(element, index) in elements2" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="2"
                      :data="data[2]"
                      :id="id + '-element2' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements2')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements2')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element" ref="bgcontainer3">
                  <!--Boton de Editar Subsección-->
                  <div class="btns-menu">
                    <b-dropdown
                      :id="'editarSub-' + id"
                      size="sm"
                      right
                      :class="{ ocultarClass: esHome }"
                      text="Editar Subsección"
                      variant="primary"
                    >
                      <b-dropdown-item @click=";(modalShow = !modalShow), (refbg = 3)">
                        <font-awesome-icon icon="fill-drip" />Editar fondo
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          ;(modalShowBorder = !modalShowBorder), (refbg = 3)
                        "
                      >
                        <font-awesome-icon icon="fill-drip" />Agregar borde
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <!--FIN Boton de Editar Subsección-->
                  <!--array elements -->
                  <div class="soyrelative" v-for="(element, index) in elements3" :key="index">
                    <Elemento
                      :elementid="index"
                      :idSection="id"
                      :subid="3"
                      :data="data[3]"
                      :id="id + '-element0' + index"
                      :esHome="esHome"
                      :online="online"
                    />
                    <b-badge
                      :class="{ ocultarClass: esHome }"
                      href="#"
                      variant="danger"
                      class="align-self-start delElement"
                      v-on:click="deleteElement(index, 'elements3')"
                    >
                      <font-awesome-icon icon="times" />
                    </b-badge>
                  </div>
                  <b-button
                    block
                    variant="success"
                    :class="{ ocultarClass: esHome }"
                    @click="addElement('elements3')"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />Agregar elemento
                  </b-button>
                  <!--FIN array elements-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--NOTE LAYOUT DEFAULT (8)-->
      <div v-if="selected_layout == 'default'" key="layout-default">
        <div id="ocho" class="section container-fluid px-0 layout">
          <div class="wrapp">
            <b-badge
              :class="{ ocultarClass: esHome }"
              class="clic"
              variant="info"
              v-on:click="toggleElement(id + 'title', stateT, 0)"
            >{{ message }}</b-badge>
            <div class="row">
              <div :id="id + 'title'" class="col m-2 title-section">{{ this.name }}</div>
            </div>
            <div class="layout">
              <div class="row">
                <div class="col m-2 element">
                  <!--NOTE data es el arreglo que contiene todos los elementos de una seccion en
                  especifico, como ya sabemos donde van posicionados los elementos le pasamos el
                  index al arreglo.-->
                  <Elemento
                    :data="data[0]"
                    :idSection="this.id"
                    :subid="0"
                    :id="this.id + '-element0'"
                    :esHome="esHome"
                    :online="online"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element">
                  <Elemento
                    :data="data[1]"
                    :idSection="this.id"
                    :subid="1"
                    :id="this.id + '-element1'"
                    :esHome="esHome"
                    :online="online"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element">
                  <Elemento
                    :data="data[2]"
                    :idSection="this.id"
                    :subid="2"
                    :id="this.id + '-element2'"
                    :esHome="esHome"
                    :online="online"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col m-2 element">
                  <Elemento
                    :data="data[3]"
                    :idSection="this.id"
                    :subid="3"
                    :id="this.id + '-element3'"
                    :esHome="esHome"
                    :online="online"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <!--Modal cambia el layout de la sección-->
    <b-modal
      :id="this.id + 'modal-layouts'"
      ref="modal"
      size="xl"
      title="Cambiar Layout"
      no-close-on-backdrop
    >
      <p class="my-4">Selecciona un layout</p>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <!-- Modal body -->
        <b-form-group class="d-flex">
          <div class="d-flex flex-wrap">
            <b-form-radio v-model="selected_layout" name="uno" value="uno">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/1.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="unovar" value="unovar">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/1var.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="dos" value="dos">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/2.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="dosvar" value="dosvar">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/2var.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="tres" value="tres">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/3.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="tresvar" value="tresvar">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/3var.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="cuatro" value="cuatro">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/4.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="cinco" value="cinco">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/5.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="seis" value="seis">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/6.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="seisvar" value="seisvar">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/6var.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="siete" value="siete">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/7.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="sietevar" value="sietevar">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/7var.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="ocho" value="ocho">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/8.png" />
              </div>
            </b-form-radio>

            <b-form-radio v-model="selected_layout" name="nueve" value="nueve">
              <div class="select-layout m-2">
                <img src="@/assets/imgs/layouts/9.png" />
              </div>
            </b-form-radio>
          </div>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button
          size="sm"
          variant="success"
          :class="{ ocultarClass: esHome }"
          @click="ok(), saveLayout()"
        >Guardar</b-button>
      </template>
    </b-modal>

    <!--Modal cambia el fondo de la sub-sección-->
    <b-modal v-model="modalShow" ref="subbg" size="sm" title="Cambiar fondo" no-close-on-backdrop>
      <!--Color sólido de fondo-->
      <div>
        <label for="type-color" class="font-weight-bold">Color de Fondo:</label>
        <b-form-input v-model="bgcolorsub" id="type-color" type="color"></b-form-input>
      </div>
      <!--Opacidad del color de fondo-->
      <div>
        <label for="type-range" class="font-weight-bold">Opacidad del Fondo:</label>
        <b-form-input v-model="opbg" id="type-range" type="range" min="0" max="10"></b-form-input>
        <p>Valor: {{ opbg }}</p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button
          size="sm"
          variant="success"
          :class="{ ocultarClass: esHome }"
          @click="cambiarBG(bgcolorsub, opbg, refbg)"
        >Guardar</b-button>
      </template>
    </b-modal>

    <!--Modal cambia el borde de la sub-seccion-->
    <b-modal
      v-model="modalShowBorder"
      ref="subbg"
      size="sm"
      title="Cambiar el borde"
      no-close-on-backdrop
    >
      <!--Color sólido de fondo-->
      <div>
        <label for="type-color" class="font-weight-bold">Color del Borde:</label>
        <b-form-input v-model="borderColor" type="color"></b-form-input>
      </div>
      <hr />
      <p class="font-weight-bold">Estilo del Borde</p>
      <b-button-toolbar class="m-1 justify-content-center">
        <b-button
          class="m-1"
          size="sm"
          variant="info"
          style="border: 2px solid black"
          v-on:click="borderStyle = 'solid'"
        >Solid</b-button>
        <b-button
          class="m-1"
          size="sm"
          variant="info"
          style="border: 2px dotted black"
          v-on:click="borderStyle = 'dotted'"
        >Dotted</b-button>
        <b-button
          class="m-1"
          size="sm"
          variant="info"
          style="border: 2px dashed black"
          v-on:click="borderStyle = 'dashed'"
        >Dashed</b-button>
        <b-button
          class="m-1"
          size="sm"
          variant="info"
          style="border: 1px double black"
          v-on:click="borderStyle = 'double'"
        >Double</b-button>
        <b-button class="m-1" size="sm" variant="info" v-on:click="borderStyle = 'none'">Ninguno</b-button>
      </b-button-toolbar>
      <hr />
      <div>
        <label for="type-color" class="font-weight-bold">Grosor del Borde:</label>
        <b-form-input v-model="borderSize" type="number"></b-form-input>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button
          size="sm"
          variant="success"
          :class="{ ocultarClass: esHome }"
          @click="cambiarBorder(borderColor, borderStyle, borderSize, refbg)"
        >Guardar</b-button>
      </template>
    </b-modal>

    <!--Modal cambia el fondo de la sección-->
    <b-modal
      :id="this.id + 'modal-bg'"
      ref="modalbg"
      size="sm"
      title="Cambiar fondo"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      no-close-on-backdrop
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <!--Color sólido de fondo-->
        <label for="favcolor">Color de Fondo:</label>
        <input ref="color" type="color" id="favcolor" name="favcolor" />
        <!--Escoger imagen-->
        <b-form-file
          size="sm"
          accept="image/*"
          browse-text="Abrir"
          placeholder="Imagen"
          :file-name-formatter="setBG"
        ></b-form-file>
        <img ref="myBG" class="w-50" />
        <!--Posición del fondo-->
        <b-form-group class="d-flex">
          <p class="my-2">Posición del fondo</p>
          <div class="d-flex flex-wrap">
            <b-form-radio v-model="bg_position" name="center" value="center" class="m-1">Centrar</b-form-radio>
            <b-form-radio v-model="bg_position" name="cover" value="cover" class="m-1">Cubrir</b-form-radio>
            <b-form-radio v-model="bg_position" name="contain" value="contain" class="m-1">Contener</b-form-radio>
          </div>
        </b-form-group>
        <!--Fondo se repite-->
        <b-form-group class="d-flex">
          <p class="my-2">Repetir fondo</p>
          <div class="d-flex flex-wrap">
            <b-form-radio
              v-model="bg_repeat"
              name="no-repeat"
              value="no-repeat"
              class="m-2"
            >No repetir</b-form-radio>
            <b-form-radio v-model="bg_repeat" name="repeat" value="repeat" class="m-2">Repetir</b-form-radio>
          </div>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button
          size="sm"
          variant="success"
          :class="{ ocultarClass: esHome }"
          @click="ok()"
        >Guardar</b-button>
      </template>
    </b-modal>

    <div class="row d-flex flex-row justify-content-end">
      <div class="p-0 likes-circles bg-warning">
        <!-- <div
          class="  "
          
        >-->
        <div @click="liked_method" style="width: 4.5em;">
          <span :class="{ 'text-white': liked }" class="h4 span-de-likes">
            {{
            this.likes
            }}
          </span>
          <img v-if="liked" class="pt-2" style="height: 4em" src="@/assets/Icons/like_full.svg" alt />
          <img v-else style="height: 4.5em" src="@/assets/Icons/like_empty.svg" alt />
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Elemento from '@/components/Elemento.vue'
import axios from 'axios'
import firebase from 'firebase'
//import EventBus from '@/components/EventBus'
export default {
  name: 'Section',
  components: { Elemento },
  props: {
    index: String,
    //name: String,
    id: String,
    esHome: Boolean,
    online: Boolean
  },
  data() {
    return {
      name: '',
      localRoot: null,
      sectionJSON: null,
      selected_layout: 'default',
      link: '',
      message: 'mostrar/ocultar',
      selectedseccs: [],
      nameState: null,
      nameState2: null,
      editar: true,
      elements0: [1],
      elements1: [1],
      elements2: [1],
      elements3: [1],
      typeElemento: '',
      stateT: 1,
      bg_position: 'cover',
      bg_repeat: 'no-repeat',
      bgcolor: '#ffffff',
      nameBG: '',
      firebaseURL: '',
      content: [],
      colorTitle: '#000000',
      typeModal: 'modal-layouts',
      data: [
        {
          name: 'secciones',
          index: 0
        },
        {
          name: 'secciones',
          index: 1
        },
        {
          name: 'secciones',
          index: 2
        },
        {
          name: 'secciones',
          index: 3
        }
      ],
      liked: false, // Define si la seccion ya fue marcada con 'Me gusta'
      likes: 0,
      bgcolorsub0: '#ffffff',
      bgcolorsub: ['pink', 'pink', 'pink', 'pink'],
      bordersub: ['none', 'none', 'none', 'none'],
      opbg: 10,
      modalShow: false,
      modalShowBorder: false,
      borderSize: 1,
      borderColor: '#000000',
      borderStyle: 'solid',
      refbg: 0
    }
  },

  created() {
    //TODO obtiene los likes de la seccion
    if (!firebase.auth().currentUser) {
      let revistaVieja = window.localStorage.getItem('revistaNum')
      let local_root = JSON.parse(window.localStorage.getItem('root'))

      // let dated = new Date()
      // let mes = dated.getMonth() + 1
      // let year = dated.getFullYear()
      if (revistaVieja == '07' || revistaVieja == '08') {
        axios
          .post('get_likes.php', {
            revistaOld: revistaVieja
          })
          .then(resp => {
            // console.log(resp.data.result)
            let likes_array = resp.data.result
            likes_array.forEach(element => {
              if (element.seccion === this.id) this.likes = element.likes
            })
          })
          .catch(Error => {
            console.log(Error)
          })
      } else {
        let dated = local_root['detalles'][0]['fecha'].split('-')
        let mes = dated[1]
        let year = dated[0]
        axios
          .post('get_likes.php', {
            year: year,
            mes: mes,
            revistaOld: revistaVieja
          })
          .then(resp => {
            // console.log(resp.data.result)
            let likes_array = resp.data.result
            likes_array.forEach(element => {
              if (element.seccion === this.id) this.likes = element.likes
            })
          })
          .catch(Error => {
            console.log(Error)
          })
      }
    }
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    //NOTE obtenemos el arreglo de 'subsecciones'(elementos) de la seccion correspondiente
    //con el prop id que nos pasó home.
    this.data = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ]
    if (this.online) {
      // console.log('Estoy en ONLINE')

      this.nameBG = this.localRoot['componentes']['secciones'][this.id][
        'bg-img'
      ][0]['url']
    } else {
      // console.log('Estoy en OFFLINE')

      this.nameBG = this.localRoot['componentes']['secciones'][this.id][
        'bg-img'
      ][0]['name']
    }

    this.bg_position = this.localRoot['componentes']['secciones'][this.id][
      'bg-position'
    ]
    this.bg_repeat = this.localRoot['componentes']['secciones'][this.id][
      'bg-repeat'
    ]
    this.bgcolor = this.localRoot['componentes']['secciones'][this.id][
      'bg-color'
    ]
    this.selected_layout = this.localRoot['componentes']['secciones'][this.id][
      'layout'
    ]
    this.stateT = this.localRoot['componentes']['secciones'][this.id]['stateT']
    this.name = this.localRoot['componentes']['secciones'][this.id]['titulo']
    this.colorTitle = this.localRoot['componentes']['secciones'][this.id][
      'colorTitle'
    ]

    /*NEVOS ARREGLOS DE ELEMENTOS*/
    this.elements0 = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][0]['elements']
    this.elements1 = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][1]['elements']
    this.elements2 = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][2]['elements']
    this.elements3 = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][3]['elements']

    /*Colores de fondo de las subsecciones*/
    this.bgcolorsub[0] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][0]['bgcolor']
    this.bgcolorsub[1] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][1]['bgcolor']
    this.bgcolorsub[2] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][2]['bgcolor']
    this.bgcolorsub[3] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][3]['bgcolor']

    /*Bordes de las subsecciones*/
    /*TODO cambiar en el json el nombre de position por border */
    this.bordersub[0] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][0]['position']
    this.bordersub[1] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][1]['position']
    this.bordersub[2] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][2]['position']
    this.bordersub[3] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][3]['position']
    // console.log('created' + this.bordersub[0])
    // this.$refs.bgcontainer0.style.border = this.bordersub[0]
    // this.$refs.bgcontainer1.style.border = this.bordersub[1]
    // this.$refs.bgcontainer2.style.border = this.bordersub[2]
    // this.$refs.bgcontainer3.style.border = this.bordersub[3]
    // console.log(this.nameBG + 'NOMBRE-BG')
  },
  mounted() {
    let section = document.getElementById(this.id)
    if (this.online) {
      section.style.backgroundImage = 'url("' + this.nameBG + '")'
    } else {
      section.style.backgroundImage = 'url(" imgs/' + this.nameBG + '")'
    }
    section.style.backgroundSize = this.bg_position
    section.style.backgroundRepeat = this.bg_repeat
    section.style.backgroundColor = this.bgcolor
    if (this.stateT === 0) {
      let element = document.getElementById(this.id + 'title')
      element.style.display = 'none'
    }
    //let itemBG = this.$refs.myBG
    //itemBG.src = this.nameBG

    this.$refs.bgcontainer0.style.backgroundColor = this.bgcolorsub[0]
    this.$refs.bgcontainer1.style.backgroundColor = this.bgcolorsub[1]
    this.$refs.bgcontainer2.style.backgroundColor = this.bgcolorsub[2]
    this.$refs.bgcontainer3.style.backgroundColor = this.bgcolorsub[3]
    this.bordersub[0] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][0]['position']
    this.bordersub[1] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][1]['position']
    this.bordersub[2] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][2]['position']
    this.bordersub[3] = this.localRoot['componentes']['secciones'][this.id][
      'subsecciones'
    ][3]['position']
    // this.$refs.bgcontainer0.style.border = this.bordersub[0]
    // this.$refs.bgcontainer1.style.border = this.bordersub[1]
    // this.$refs.bgcontainer2.style.border = this.bordersub[2]
    // this.$refs.bgcontainer3.style.border = this.bordersub[3]
    // console.log('mounted' + this.bordersub[0])
  },

  methods: {
    addElement(index) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      /*NEVOS ARREGLOS DE ELEMENTOS*/
      this.elements0 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][0]['elements']
      this.elements1 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][1]['elements']
      this.elements2 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][2]['elements']
      this.elements3 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][3]['elements']
      const newElement = {}
      newElement.type = 'Texto'
      newElement.id = ''
      newElement.src = [
        {
          name:
            '<p class="ql-align-center">Inserta </p><p class="ql-align-center">un</p><p class="ql-align-center">elemento</p>',
          url:
            'https://firebasestorage.googleapis.com/v0/b/buro-app.appspot.com/o/imagenes%2Fsampleimg.png?alt=media&token=e91303c7-80e1-47cd-942d-3c95ef72ab41'
        }
      ]
      newElement.margin = {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      }
      newElement.padding = {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
      newElement.position = 'center'
      newElement.animation = 'lr'
      newElement.size = '50'
      newElement.gallery_settings = [
        { existeGaleria: false },
        {
          images: 'Ahhh',
          carousel: 'AAyy',
          audio: null
        }
      ]
      newElement.extras = []

      switch (index) {
        case 'elements0':
          this.elements0.push(newElement)
          this.localRoot['componentes']['secciones'][this.id][
            'subsecciones'
          ][0]['elements'] = this.elements0
          break

        case 'elements1':
          this.elements1.push(newElement)
          this.localRoot['componentes']['secciones'][this.id][
            'subsecciones'
          ][1]['elements'] = this.elements1
          break

        case 'elements2':
          this.elements2.push(newElement)
          this.localRoot['componentes']['secciones'][this.id][
            'subsecciones'
          ][2]['elements'] = this.elements2
          break

        case 'elements3':
          this.elements3.push(newElement)
          this.localRoot['componentes']['secciones'][this.id][
            'subsecciones'
          ][3]['elements'] = this.elements3
          break
        default:
          break
      }

      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      console.log('te cache')
    },
    deleteElement(index, array_id) {
      //EventBus.$on('DELETE_INDEX', delIndex => {

      console.log(index)
      //console.log(delIndex)
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      /*NEVOS ARREGLOS DE ELEMENTOS*/
      this.elements0 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][0]['elements']
      this.elements1 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][1]['elements']
      this.elements2 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][2]['elements']
      this.elements3 = this.localRoot['componentes']['secciones'][this.id][
        'subsecciones'
      ][3]['elements']
      switch (array_id) {
        case 'elements0':
          this.$delete(this.elements0, index)
          //this.localRoot['componentes']['secciones'][this.id][
          //'subsecciones'
          //][0]['elements'] = this.elements0
          console.log(this.elements0)
          break

        case 'elements1':
          this.$delete(this.elements1, index)
          this.localRoot['componentes']['secciones'][this.id][
            'subsecciones'
          ][1].elements = this.elements1
          break

        case 'elements2':
          this.$delete(this.elements2, index)
          //this.localRoot['componentes']['secciones'][this.id][
          //'subsecciones'
          //][2].elements = this.elements2
          console.log(this.elements2)
          break

        case 'elements3':
          this.$delete(this.elements3, index)
          this.localRoot['componentes']['secciones'][this.id][
            'subsecciones'
          ][3].elements = this.elements3
          break
        default:
          break
      }
      // })
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    changeComponentName(newName) {
      this.name = newName
      this.id = newName
      this.$emit('name', this.id)
    },
    onSubmit(evt) {
      evt.preventDefault()
      this.changeName()
    },
    close() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.name = this.localRoot['componentes']['secciones'][this.id]['titulo']
      this.$refs[this.id + 'changeName'].hide()
    },
    changeName() {
      if (this.name.length <= 0) {
        console.log('cero')
        return
      }
      console.log('soy ' + this.name)
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.id]['titulo'] = this.name
      this.localRoot['componentes']['secciones'][this.id][
        'colorTitle'
      ] = this.colorTitle
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.$nextTick(() => {
        this.$bvModal.hide(this.id + 'changeName')
      })
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      //this.typeModal = 'modal-layouts'
    },
    handleOk() {
      // Prevent modal from closing
      //bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      let color = this.$refs.color.value
      this.bgcolor = color
      let master = document.getElementById(this.id)
      master.style.backgroundColor = color
      if (this.bg_position === 'center') {
        master.style.backgroundPosition = 'center'
      } else master.style.backgroundSize = this.bg_position
      master.style.backgroundRepeat = this.bg_repeat

      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.id][
        'bg-position'
      ] = this.bg_position
      this.localRoot['componentes']['secciones'][this.id][
        'bg-repeat'
      ] = this.bg_repeat
      this.localRoot['componentes']['secciones'][this.id][
        'bg-color'
      ] = this.bgcolor
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.id + this.typeModal)
      })
    },
    agregarElemento(elemento) {
      let btn = document.getElementById('insertarE')
      this.typeElemento = elemento
      btn.style.display = 'none'
    },
    eliminarElemento() {
      let btn = document.getElementById('insertarE')
      this.typeElemento = ''
      btn.style.display = 'inline-block'
    },
    setBG(file) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.typeModal = 'modal-bg'

      if (file.length === 1) {
        let locationStorage = '/imagenes/'
        let storageRef = firebase.storage().ref(locationStorage + file[0].name)
        let uploadTask = storageRef.put(file[0])

        uploadTask.on(
          'state_changed',
          snapshot => {
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING:
                console.log('Upload is running')
                break
            }
          },
          error => {
            console.log(error)
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.firebaseURL = downloadURL

              let section = document.getElementById(this.id)
              section.style.backgroundImage = 'url(' + this.firebaseURL + ')'
              this.localRoot = JSON.parse(window.localStorage.getItem('root'))
              this.localRoot['componentes']['secciones'][this.id]['bg-img'][0][
                'url'
              ] = this.firebaseURL
              this.localRoot['componentes']['secciones'][this.id]['bg-img'][0][
                'name'
              ] = file[0].name
              let parsedRoot = JSON.stringify(this.localRoot)
              window.localStorage.setItem('root', parsedRoot)

              //alert('La imagen se ha subido!')
              // Obtengo el elemento DOM de la imagen
              let itemBG = this.$refs.myBG
              itemBG.src = this.firebaseURL
            })
          }
        )
      } else {
        return alert('Solo se puede subir una imagen')
      }
    },
    saveLayout() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.id][
        'layout'
      ] = this.selected_layout
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    //Muestra/oculta el titulo de una sección
    toggleElement(id, action, index) {
      console.log(index)
      if (action === 1) {
        let element = document.getElementById(id)
        element.style.display = 'none'
        this.stateT = 0
        console.log('ocultar')
      } else {
        console.log('mostrar')
        let element = document.getElementById(id)
        element.style.display = 'block'
        this.stateT = 1
      }
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.id][
        'stateT'
      ] = this.stateT
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },

    // Metodo para a;adir un like a la seccion
    liked_method() {
      console.log('clicked')

      if (this.liked === true) {
        alert('Solo puedes dar like una vez por articulo.')
        return
      } else {
        let local_root = JSON.parse(window.localStorage.getItem('root'))
        let dated = local_root['detalles'][0]['fecha'].split('-')
        let mes = dated[1]
        let year = dated[0]
        // TODO aqui va el axios para insertar
        // console.log('el form es:')

        // let form = new FormData()
        // form.append('seccion', this.index)
        // console.log(form.get('seccion'))

        // axios
        //   .post('inserta_likes.php', { form })
        //   .then(resp => {
        //     console.log(resp.data)
        //   })
        //   .catch(Error => {
        //     console.log(Error)
        //   })

        axios
          .post('inserta_likes.php', {
            seccion: this.index,
            mes: mes,
            year: year
          })
          .then(() => {
            this.liked = !this.liked
            this.likes++
          })
          .catch(Error => {
            console.log(Error)
          })
      }
    },

    //ESTILOS DE SUBSECCIONES
    hexToRgbA(hex, op) {
      var c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        var opacidad
        opacidad = op / 10
        console.log(
          'rgba(' +
            [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
            ',' +
            opacidad +
            ')'
        )
        return (
          'rgba(' +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
          ',' +
          opacidad +
          ')'
        )
      }

      alert('Bad Hex' + hex + op)
    },
    cambiarBG(bgcolor, op, refbg) {
      let bg = this.hexToRgbA(bgcolor, op)
      switch (refbg) {
        case 0:
          this.$refs.bgcontainer0.style.backgroundColor = bg
          break
        case 1:
          this.$refs.bgcontainer1.style.backgroundColor = bg
          break
        case 2:
          this.$refs.bgcontainer2.style.backgroundColor = bg
          break
        case 3:
          this.$refs.bgcontainer3.style.backgroundColor = bg
          break
      }
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.id]['subsecciones'][
        refbg
      ]['bgcolor'] = bg
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.modalShow = false
    },
    cambiarBorder(color, style, size, refbg) {
      let border = size + 'px ' + color + ' ' + style
      switch (refbg) {
        case 0:
          this.$refs.bgcontainer0.style.border = border
          break
        case 1:
          this.$refs.bgcontainer1.style.border = border
          break
        case 2:
          this.$refs.bgcontainer2.style.border = border
          break
        case 3:
          this.$refs.bgcontainer3.style.border = border
          break
      }
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.id]['subsecciones'][
        refbg
      ]['position'] = border
      this.bordersub[refbg] = border
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.modalShowBorder = false
    }
  }
}
</script>

<style lang="scss">
/*SECTIONS*/

main {
  grid-area: main;
}

/*BUTTONS*/
.btn-edit {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  margin: 10px;
  display: inline-block;
}

.btns-menu button {
  position: absolute !important;
  top: -40px;
}

.btns-menu {
  line-height: 0;
}

.layout-container {
  position: relative;
}

.wrapp {
  width: 95%;
  margin: 0 auto;
}

.layout-1 {
  background-color: pink;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.section {
  position: relative;
  padding: 0px 0px;
  margin-top: 0 !important;
}

.title-section {
  /*border: 1px black dotted;*/
  margin: 5px 0px;
  padding: 15px;
  font-size: 28px;
  /*background-color: rgba(256, 256, 256, 0.5);*/
}

.element {
  /*border: 1px black dotted;*/
  position: relative;
  /*margin: 5px 0px;*/
  padding: 5px !important;
  /*background-color: rgba(256, 256, 256, 0.5);*/
}

.element-content {
  position: relative;
}

.layout {
  min-height: 100vh;
  margin-top: 10px;
}

/*individuals*/
#uno {
  background-color: #cd84f1;
}
#uno-var {
  background-color: #c56cf0;
}
#dos {
  background-color: #ffcccc;
}
#dos-var {
  background-color: #ffb8b8;
}
#tres {
  background-color: #ff4d4d;
}
#tres-var {
  background-color: #ff3838;
}
#cuatro {
  background-color: #ffaf40;
}
#cinco {
  background-color: #fffa65;
}
#seis {
  background-color: #32ff7e;
}
#seis-var {
  background-color: #3ae374;
}
#siete {
  background-color: #7efff5;
}
#siete-var {
  background-color: #67e6dc;
}
#ocho {
  background-color: #18dcff;
}

#uno,
#uno-var,
#dos,
#dos-var,
#tres,
#tres-var,
#cuatro,
#cinco,
#seis,
#seis-var,
#siete,
#siete-var,
#ocho {
  background-color: transparent !important;
}

.element-bg {
  width: 100%;
  display: block;
  margin-bottom: 5px;
}
/*
#dos .layout .row,
#cuatro .layout .row,
#uno-var .layout .row,
#dos-var .layout .row,
#siete .layout .row,
#siete-var .layout .row {
  min-height: 50vh;
  .element-bg {
    min-height: 50vh;
  }
}

#tres .layout .row,
#tres-var .layout .row {
  min-height: 30vh;
  .element-bg {
    min-height: 30vh;
  }
}

#uno .layout .row,
#cinco .layout .row,
#seis .layout > .row,
#seis-var .layout > .row {
  min-height: 100vh;
  .element-bg {
    min-height: 100vh;
  }
}

#seis .layout > .row .row,
#seis-var .layout > .row .row {
  min-height: 50vh;
  .element-bg {
    min-height: 50vh;
  }
}

#ocho .layout .row {
  min-height: 25vh;
  .element-bg {
    min-height: 25vh;
  }
}
*/

/*MODALES*/
.select-layout {
  width: 100px;
  height: 100px;
}

.select-layout img {
  width: 100px;
  height: 100px;
  object-fit: fill;
}

.likes-circles {
  cursor: pointer;
  position: relative;
  border-radius: 50px;
}
.span-de-likes {
  // transform: translate(-50%, -50%);
  top: 26.5%;
  left: 40%;
  position: absolute;
  z-index: 99;
  height: 1.2rem !important;
}

.delElement {
  position: absolute;
  top: 0px;
  left: -20px;
  display: none !important;
}

.soyrelative {
  position: relative;
}
</style>
